import { Component, OnInit } from '@angular/core';
import { MapConstants } from 'src/app/utils/map.constant';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined } from 'util';

import { ConstantsModule } from '../../shared/constants/constants.module';
import { UtilsSharedModule } from '../../shared/utils/utils/utils.module';
import { ActualRainfallConstants } from './utils/constant/actual-rainfall.constant';
import { MapService } from './utils/service/map.service';
import { DataService } from './utils/service/data.service';

@Component({
  selector: 'app-actual-rainfall',
  templateUrl: './actual-rainfall.component.html',
  styleUrls: ['./actual-rainfall.component.scss']
})
export class ActualRainfallComponent implements OnInit {

  initializeBool = true;
  stateName: any;
  layerList: any = [];
  otherOptions: {};
  urlParams: any;
  commonLayers: any;
  stateId = 'akbm';
  Layers = [
    {
      Component: this.constants.COMPONENT.RAINFALL,
      SRC: this.constants.IMD_STATIONS,
      LayerName: 'RAINFALL_HEATMAP',
      DisplayName: 'Rainfall Heatmap',
      LayerType: 'IMAGE_LAYER',
      DefaultSelect: true,
      ServiceType: 'HeatMap',
      url: 'rf/heatmap',
      Filter: null,
      Legend: 'RAINFALL_HEATMAP',
      onSourceChange: true,
      home: true,
    }
  ];

  constructor(
    private utilsShared: UtilsSharedModule,
    private constants: ConstantsModule,
    private dataService: DataService
    ) {
    this.stateName = ProjConstants.IDTOSTATENAMEMAPPING[this.stateId];
  }

  ngOnInit() {
//     const commonLayers = this.getCommonLayers();
//     const eDate = this.utilsShared.getModelDateWithDateFormat(new Date(Date.now()), this.constants.DATEPICKER_DATE_FORMAT.DAY);
//     const sDate = this.utilsShared.getCurrentMonsoonrYearStartDate();
//     this.urlParams = {
      // aggr: this.constants.AGGR_TYPES.SUM, // 
      // cType: this.constants.LOCATION_CONSTANT.DISTRICT, //
//       chartType: 'stock',
//       component: this.constants.COMPONENT.RAINFALL,COUNTRY
//       daterange: 'Monsoon YTD',
//       eDate, //
      // format: this.constants.DATEPICKER_DATE_FORMAT.DAY, //
//       handleEventFromBreadcrumb: false,
//       lType: this.constants.LOCATION_CONSTANT.STATE,
//       lUUID: this.constants.ANDHRA_PRADESH_UUID,
//       locname: ProjConstants.STATENAME,
//       loctype: this.constants.LOCATION_CONSTANT.STATE,
//       locuuid: this.constants.ANDHRA_PRADESH_UUID,
//       luuid: this.constants.ANDHRA_PRADESH_UUID,
//       mapOnClickParams: false,
//       pEUUID: this.constants.ANDHRA_PRADESH_UUID, //
      // pUUID: this.constants.ANDHRA_PRADESH_UUID,  //
//       sDate, //
//       sUUID: this.constants.ANDHRA_PRADESH_UUID,
      // src: this.constants.IMD_GRID, // 
//       type: 'ACTUAL',
//       view: this.constants.VIEWS.ADMIN, //
//       ytd: new Date().getFullYear().toString()
//           //  "pType": "COUNTRY",

// //           "classification": [
// // //         "ACTUAL"
// // //     ],
//     };

    const commonLayers = this.getCommonLayers();
    const now = new Date();
    const eDate = new Date(now);
    const eYear = eDate.getFullYear();
    const eMonth = (eDate.getMonth() + 1).toString().padStart(2, '0');
    const eDay = eDate.getDate().toString().padStart(2, '0');
    const eDateFormatted = `${eYear}${eMonth}${eDay}`;
    const sDate = new Date(now);
    sDate.setDate(sDate.getDate() - 1);
    const sYear = sDate.getFullYear();
    const sMonth = (sDate.getMonth() + 1).toString().padStart(2, '0');
    const sDay = sDate.getDate().toString().padStart(2, '0');
    const sDateFormatted = `${sYear}${sMonth}${sDay}`;
    this.urlParams = {
      pUUID: this.constants.COUNTRY_UUID,
      pType: this.constants.LOCATION_CONSTANT.COUNTRY,
      cType: this.constants.LOCATION_CONSTANT.BLOCK,
      format: this.constants.DATEPICKER_DATE_FORMAT.DAILY,
      src: this.constants.IMD_STATIONS,
      sDate: sDateFormatted,
      eDate: eDateFormatted,
      aggr: this.constants.AGGR_TYPES.SUM,
      pEUUID: this.constants.COUNTRY_UUID,
      "classification": [
        "ACTUAL"
      ],
      view: 'admin'
    }
    let layers = [];
    layers = layers.concat(commonLayers);
    const timeLayers = this.getTimeLayers();
    layers = layers.concat(timeLayers);
    this.layerList = layers;
    this.getOtherOptions();
  }

  getCommonLayers() {
    const layerList: any = ActualRainfallConstants.CommonLayers;
    for (const i in layerList) {
      if (!isNullOrUndefined(i)) {
        const layer = layerList[i];
        layer['stateName'] = this.stateName;
        if (layer.layerNameType) {
          if (layer['serviceType'] === 'VectorLayer') {
            layer['layerName'] = ProjConstants.STATE_TO_LAYERTYPE_NAME[this.stateName + '_' + layer.layerNameType];
          } else {
            layer['layerName'] = MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + ProjConstants.STATE_TO_LAYERTYPE_NAME[this.stateName + '_' + layer.layerNameType];
          }
        }
      }
    }
    return layerList;
  }

  getTimeLayers() {
    const timeLayers = this.Layers;
    const layers = [];
    for (const i in timeLayers) {
      if (!isNullOrUndefined(i)) {
        const layer = timeLayers[i];
        if (layer.SRC == this.urlParams['src']) {
          let layerObj = {};
          if (layer.ServiceType == 'HeatMap') {
            layerObj = { ...ActualRainfallConstants.HeatMapOptions };
            layerObj['postData'] = this.urlParams;
          }
          if(layer.ServiceType == 'CroppedHeatMap'){
            layerObj = { ...ActualRainfallConstants.CroppedHeatMapOptions };
            layerObj['postData'] = this.urlParams;  
          }
          layerObj['stateName'] = this.stateName;
          layerObj['view'] = 'admin'
          layerObj['groupName'] = 'current';
          layerObj['setDefault'] = 'true';
          layerObj['url'] = layer.url;
          layerObj['layerName'] = 'Rainfall Actual';
          if (layer.Component) {
            layerObj['Component'] = layer.Component;
          }
          if (layer.SRC) {
            layerObj['SRC'] = layer.SRC;
          }
          if (layer.Filter) {
            layerObj['Filter'] = layer.Filter;
          }
          if (layer['hasFormatting']) {
            layerObj['hasFormatting'] = layer['hasFormatting'];
          }
          if (layer['formattingUrl']) {
            layerObj['formattingUrl'] = layer['formattingUrl'];
          }
          if (layer['pointToLayer']) {
            layerObj['PointToLayer'] = layer['pointToLayer'];
          }
          if (layer['onEachFeature']) {
            layerObj['OnEachFeature'] = layer['onEachFeature'];
          }
          if (layer.LayerName) {
            layerObj['LayerName'] = layer.LayerName;
          }
          const bounds = {
            southWest: { latitude: 6.33, longitude: 67.57 },
            northEast: { latitude: 35.4, longitude: 97.23 }
          };

          layerObj['heatMapImageBound'] = { "southWest": { "latitude": 6.762376, "longitude": 68.144846 }, "northEast": { "latitude": 37.07827, "longitude": 97.46739 } }
          // layerObj['postData']['sUUID'] = ProjConstants.STATETOUUIDMAPPING['COUNTRY'];
          // layerObj['postData']['daterange'] = 'Monsoon YTD';
          layers.push(layerObj);
        }
      }
    }
    return layers;
  }

  getOtherOptions() {
    const otherOptions = {};
    otherOptions['legend'] = this.getLegendData();
    otherOptions['service'] = MapService;
    otherOptions['urlParams'] = this.urlParams;
    otherOptions['addInverseMask'] = false;
    otherOptions['reloadAllTimeLayers'] = false;
    this.otherOptions = otherOptions;
  }

  getLegendData() {
    // const params = this.urlParams;
    // const startDate = params['sDate'] || this.utilsShared.getModelDateFromDate(new Date());
    // const endDate = params['eDate'] || this.utilsShared.getModelDateFromDate(new Date());
    // const format = params['format'] || this.constants.DATEPICKER_DATE_FORMAT.DAY;
    // const noOfDays = 1 + this.utilsShared.getNumberOfDaysBetweenTwoModelDates(startDate, endDate, format);
    // if (params['aggr'] != this.constants.AGGR_TYPES.SUM) {
    //   if (format == this.constants.DATEPICKER_DATE_FORMAT.DAY) { return ActualRainfallConstants.Legend.LOW; }
    //   if (format == this.constants.DATEPICKER_DATE_FORMAT.MONTH) { return ActualRainfallConstants.Legend.MED; }
    //   if (format == this.constants.DATEPICKER_DATE_FORMAT.YEAR) { return ActualRainfallConstants.Legend.HIGH; }
    // } else {
    //   if (noOfDays <= 6) { return ActualRainfallConstants.Legend.CURRENT_DATE; }
    //   if (noOfDays > 6) { return ActualRainfallConstants.Legend.PAST_DATE; }
    // }
    // return ActualRainfallConstants.Legend.CURRENT_DATE;
  }

}
